import React from 'react';
import { Select } from 'antd';
import { InPageSpinner } from '@components/spinners/in-page-spinner';
import { TIME_RANGE_OPTIONS } from '../../constants';
import { StatCard } from '../../dag-detail/overview-tab/stat-card';
import { InstancesChart } from './instances-chart';
import { useOverviewTab } from './use-overview-tab';
import styles from '../../styles.module.scss';

const { Option } = Select;

type OverviewTabProps = {
    dagId: string;
    taskId: string;
    refreshKey: number;
};

/*
 * DAG-task detail's Overview tab — failed-instances stat card and recent-instances duration chart
 */
export function OverviewTab({ dagId, taskId, refreshKey }: OverviewTabProps) {
    const { timeRange, setTimeRange, failedTotal, failedSeries, chartPoints, isLoading } = useOverviewTab(dagId, taskId, refreshKey);

    if (isLoading) return <InPageSpinner size="Small" />;

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <h3 style={{ margin: 0, color: '#fff', fontSize: 14, fontWeight: 700, letterSpacing: 0.25 }}>Performance Overview</h3>
                <Select value={timeRange} onChange={setTimeRange} style={{ width: 160 }}>
                    {TIME_RANGE_OPTIONS.map((option) => (
                        <Option key={option.value} value={option.value}>
                            {option.label}
                        </Option>
                    ))}
                </Select>
            </div>
            <div style={{ marginBottom: 16, maxWidth: 300 }}>
                <StatCard title="Failed Task Instances" total={failedTotal} series={failedSeries} color="#ff4d4f" />
            </div>
            <div className={styles.card}>
                <h3 style={{ margin: '0 0 8px', color: '#fff', fontSize: 14, fontWeight: 700, letterSpacing: 0.25 }}>{`Last ${chartPoints.length} Task Instances`}</h3>
                <InstancesChart points={chartPoints} />
            </div>
        </div>
    );
}
